export const selectAnsweredCall = (state) => [state.answeredCall, state.setAnsweredCall]
